import { forwardRef } from 'react';
import techTennisLogo from '../assets/techtennis_logo_wimbledon.png';

export const CycleReportTemplate = forwardRef<HTMLDivElement, any>(({ schedule, studentName, cycleType, periodText }, ref) => {
  if (!schedule || schedule.length === 0) return null;

  const pageStyle = {
    width: '794px',
    minHeight: '1123px',
    padding: '40px',
    background: 'white',
    fontFamily: 'system-ui, -apple-system, sans-serif',
    color: '#111827',
    boxSizing: 'border-box' as const,
    marginBottom: '20px'
  };

  const ReportHeader = () => (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '2px solid #E5E7EB', paddingBottom: '20px', marginBottom: '20px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
        <img src={techTennisLogo} alt="TechTennis" style={{ maxHeight: '70px', maxWidth: '180px', objectFit: 'contain' }} />
        <div>
          <h1 style={{ margin: 0, fontSize: '24px', color: '#1E3A8A' }}>Relatório de Acompanhamento - {cycleType}</h1>
          <h2 style={{ margin: '5px 0 0 0', fontSize: '16px', color: '#6B7280' }}>Aluno: {studentName}</h2>
          {periodText && <h3 style={{ margin: '5px 0 0 0', fontSize: '14px', color: '#6B7280' }}>Período: {periodText}</h3>}
        </div>
      </div>
    </div>
  );

  const chunkedSchedule = [];
  for (let i = 0; i < schedule.length; i += 3) {
    chunkedSchedule.push(schedule.slice(i, i + 3));
  }

  return (
    <div ref={ref} style={{ position: 'absolute', left: '-9999px', top: '-9999px', display: 'flex', flexDirection: 'column' }}>
      {chunkedSchedule.map((pageDays, pageIndex) => (
        <div key={pageIndex} className="pdf-page" style={pageStyle}>
          <ReportHeader />
          <div style={{ marginBottom: '30px' }}>
            {pageIndex === 0 && (
              <h3 style={{ fontSize: '18px', color: '#1E3A8A', borderBottom: '1px solid #E5E7EB', paddingBottom: '5px', marginBottom: '15px' }}>Dias de Treino e Anotações</h3>
            )}
            {pageDays.map((day: any, idx: number) => (
              <div key={idx} style={{ marginBottom: '20px', padding: '15px', border: '1px solid #E5E7EB', borderRadius: '8px', background: '#F9FAFB' }}>
                <div style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '10px', color: '#374151' }}>
                  Semana {day.weekNumber} - Dia {day.dayNumber}
                </div>
                <div style={{ marginBottom: '10px' }}>
                  <strong style={{ color: '#4B5563', fontSize: '14px' }}>Exercícios: </strong>
                  <span style={{ fontSize: '14px' }}>
                    {day.exercises?.map((ex: any) => ex.title).join(', ') || day.kpis?.join(', ') || 'Nenhum exercício registrado'}
                  </span>
                </div>
                
                {(day.coachNotes || day.playerNotes) ? (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '15px' }}>
                    {day.coachNotes && (
                      <div style={{ background: 'white', padding: '10px', borderRadius: '6px', borderLeft: '4px solid #3A8E58' }}>
                        <strong style={{ fontSize: '12px', color: '#6B7280', display: 'block', marginBottom: '4px' }}>Anotações do Treinador:</strong>
                        <span style={{ fontSize: '14px' }}>{day.coachNotes}</span>
                      </div>
                    )}
                    {day.playerNotes && (
                      <div style={{ background: 'white', padding: '10px', borderRadius: '6px', borderLeft: '4px solid #1E3A8A' }}>
                        <strong style={{ fontSize: '12px', color: '#6B7280', display: 'block', marginBottom: '4px' }}>Anotações do Aluno:</strong>
                        <span style={{ fontSize: '14px' }}>{day.playerNotes}</span>
                      </div>
                    )}
                  </div>
                ) : (
                  <div style={{ marginTop: '10px', fontStyle: 'italic', color: '#9CA3AF', fontSize: '13px' }}>Sem anotações neste dia.</div>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
});
